module.exports = __webpack_public_path__ + "static/media/5.01cfb623.png";